<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <div style="position: relative">
      <v-progress-linear
        absolute
        v-show="progress"
        color="info"
        indeterminate
      ></v-progress-linear>
    </div>

    <v-card>
      <v-card-text class="pa-10">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="px-6">
            <v-text-field
              v-model="form.nome"
              :label="$t('areaName')"
              :rules="requiredRules"
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <div class="px-6">
            <v-select
              v-model="form.subArea.select"
              :items="form.subArea.items"
              item-text="name"
              item-value="id"
              :label="$t('subAreaOf')"
              outlined
              return-object
              required
              dense
            >
            </v-select>
          </div>
          <div class="px-6">
            <v-text-field
              :label="$t('areaDescroption')"
              outlined
              dense
              v-model="form.descricao"
            ></v-text-field>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateArea"
          type="submit"
          :disabled="!valid"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "administrator-areas-list-update",
  data: () => ({
    valid: false,
    loading: false,
    form: {
      id_area: "",
      id_regiao: "",
      nome: "",
      descricao: "",
      subArea: {
        select: { id: "", name: "" },
        items: [],
      },
    },
    requiredRules: [validate.required, validate.max],
    edit: false,
  }),
  async mounted() {
    // =================================================== //
    // IF - Add
    // =================================================== //
    const body = { id_regiao: "" };
    let response = await this.$request.post("administrator/areas/list", {
      body,
    });
    if (response.length == 0) return;
    this.form.subArea.items = response.dados;

    // =================================================== //
    // IF - Edit
    // =================================================== //
    if (!this.$route.params.id) {
      return;
    }
    this.edit = true;
    this.form.id_area = this.$route.params.id;
    let areaData = await this.$request.post("administrator/areas/getArea", {
      id_area: this.form.id_area,
    });
    const { descricao, id_regiao, nome } = areaData.dados;
    this.form.nome = nome;
    this.form.descricao = descricao;
    var select = this.form.subArea.items.filter((item) => {
      return item.id == id_regiao;
    });
    if (select[0]) {
      this.form.subArea.select = select[0];
    }
    // Removendo a Área selecionada de "sub-área de".
    // evitando que seja possível fazer uma área
    // sub-área dela mesmo.
    var index = this.form.subArea.items.findIndex((item) => {
      return item.id == this.form.id_area;
    });
    this.form.subArea.items.splice(index, 1);
    this.form.subArea.items.push({ id: "", name: "nenhuma" });
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    progress() {
      return this.$store.state.feedbackProgress;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async updateArea() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Form

      const body = {
        id_regiao: this.form.subArea.select.id,
        nome: this.form.nome,
        descricao: this.form.descricao,
      };

      if (this.edit) {
        Object.assign(body, { id_area: this.form.id_area });
      }

      try {
        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "administrator/areas/editArea"
          : "administrator/areas/addArea";

        const result = await this.$request.post(updateEndpoint, body);
        if (result.length == 0) return;

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
